import styled, { css } from 'styled-components';
import { mq } from 'stylesheets/utils';
export const CheckActive = styled.div<{
  readonly active?: boolean;
}>`
  max-width: 20px;
  min-width: 20px;
  height: 20px;
  border: 2px solid ${({ theme }) => theme.colors.lightPurple};
  margin-right: 12px;
  border-radius: 50%;
  position: relative;
  cursor: pointer;
  transition: 0.3s ease border-color;
  &::after {
    position: absolute;
    content: '';
    width: 12px;
    height: 12px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background-color: transparent;
  }
`;

export const Card = styled.div`
  padding: 14px 18px 13px 18px;
  border: 2px solid ${({ theme }) => theme.colors.lightPurple};
  max-width: 344px;
  min-width: 344px;
  width: 100%;
  border-radius: 4px;
  transition: 0.3s ease all;
  display: flex;
  align-items: center;
  max-height: 124px;
  transition: 0.3s ease border-color;
  ${mq(992)} {
    max-width: unset;
    width: 100%;
  }
`;

export const BrandLogo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  margin-right: 12px;
`;

export const Logo = styled.div`
  max-width: 52px;
  min-width: 52px;
  max-height: 52px;
  min-height: 52px;
  margin-bottom: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BrandData = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Div = styled.div`
  max-width: 20px;
  min-width: 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

export const Name = styled.p`
  font-size: ${({ theme }) => theme.fontsizes.body14};
  font-weight: ${({ theme }) => theme.fontWeight.font500};
  color: ${({ theme }) => theme.colors.black2};
  margin-bottom: 5px;
`;

export const P = styled.p`
  font-size: ${({ theme }) => theme.fontsizes.body12};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  margin-right: 8px;
  &:last-of-type {
    margin: 0 0 0 8px;
  }
`;

export const Info = styled.div`
  display: flex;
  margin-bottom: 14px;
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const Wrapper = styled.label<{ readonly isDisabled?: boolean }>`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  position: relative;
  cursor: pointer;
  user-select: none;
  &:hover {
    ${CheckActive} {
      border-color: ${({ theme }) => theme.colors.cartCountColor};
    }
    ${Card} {
      border-color: ${({ theme }) => theme.colors.cartCountColor};
    }
  }
  input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    &:checked {
      & + ${CheckActive} {
        border-color: ${({ theme }) => theme.colors.cartCountColor};
        &::after {
          background-color: ${({ theme }) => theme.colors.cartCountColor};
        }
        & + ${Card} {
          border-color: ${({ theme }) => theme.colors.cartCountColor};
        }
      }
    }
  }
  transition: 0.3s ease opacity, 0.3s ease border-color;
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      pointer-events: none;
      opacity: 0.7;
    `}
`;
